import { FC } from "react";
import { IconPropsType } from ".";

export const Call: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3491_8560)">
        <path
          d="M0.965909 6.57222C1.67492 3.13937 3.85648 1.22739 7.25931 0.649799C9.7748 0.222914 12.2912 0.217508 14.8025 0.661786C18.3062 1.28159 20.4125 3.30508 21.0835 6.78982C21.6019 9.48294 21.6101 12.2048 21.0754 14.8954C20.3581 18.3044 18.1202 20.4088 14.73 20.9842C12.2145 21.4111 9.69804 21.4165 7.18676 20.9722C3.68305 20.3524 1.5674 18.2279 0.896445 14.7432C0.351594 12.0323 0.404019 9.29326 0.965909 6.57217V6.57222Z"
          fill={props.color ?? "#0BCD74"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.19925 9.06926L8.08557 8.74194C8.08557 8.74194 8.76874 10.1094 10.1175 11.464C11.4663 12.8185 12.9594 13.5534 12.9594 13.5534L12.5768 14.4525C12.5768 14.4525 10.8953 13.475 9.50522 12.0789C8.11506 10.6829 7.19925 9.06926 7.19925 9.06926ZM17.1109 13.3035C17.7112 13.6033 17.8417 14.4061 17.3676 14.8822L15.3357 16.9228C15.1879 17.0713 15.0073 17.1826 14.8085 17.2476C14.6098 17.3126 14.3985 17.3294 14.192 17.2967C14.0534 17.2747 13.9152 17.2496 13.7776 17.2217C12.5371 17.0525 10.0968 16.4181 7.75103 14.0622C5.27486 11.5755 4.5688 8.78966 4.36944 7.5208C4.33689 7.31344 4.35364 7.10128 4.41834 6.90166C4.48304 6.70205 4.59385 6.52063 4.74171 6.37224L6.77376 4.33156C7.24779 3.85545 8.04718 3.98661 8.34568 4.58949L9.91395 7.75693L9.13014 8.14564L7.6766 5.18899C7.59216 5.01727 7.36476 4.97961 7.22991 5.11505L5.56605 6.78597C5.48014 6.87225 5.41295 6.97545 5.3687 7.08909C5.32445 7.20272 5.3041 7.32433 5.30893 7.44625C5.3373 8.16914 5.55032 9.55834 6.58929 11.2334C7.01609 11.8727 7.57039 12.5623 8.29073 13.2857C10.7825 15.7882 13.0397 16.2724 14.124 16.3453C14.2717 16.3424 14.3879 16.3317 14.469 16.3214C14.5762 16.3077 14.6806 16.2742 14.772 16.2164C14.8269 16.1818 14.8778 16.141 14.9237 16.095L16.5875 14.4241C16.7224 14.2886 16.6849 14.0602 16.514 13.9755L13.5698 12.5156L13.9568 11.7284L17.1109 13.3035Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3491_8560">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
